import { render, staticRenderFns } from "./ListingRentalRoomsComponent.vue?vue&type=template&id=3bbf0685&"
import script from "./ListingRentalRoomsComponent.vue?vue&type=script&lang=js&"
export * from "./ListingRentalRoomsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports